





















import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  DrivewealthAccountManagementType
} from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class InvestmentAccountTypeSlots extends Vue {
  featureFlagStore = useFeatureFlagStore();
  drivewealthWizardStore = useDrivewealthWizardStore();
  drivewealthStore = useDrivewealthStore();

  @Prop({ required: false, default: false })
  showLoading: boolean;

  mounted (): void {
    this.drivewealthStore.loadDefaultAccount();
    this.drivewealthWizardStore.loadAllowedInvestmentAccountTypes({});
    if (this.isLoaded && this.onlyOneChoice) {
      this.oneChoiceValueChanged();
    }
  }

  get isLoaded (): boolean {
    return this.featureFlagStore.featureFlagsAvailable && this.drivewealthWizardStore.enrollmentTypeLoaded
        && this.drivewealthStore.drivewealthLoaded
        && !this.showLoading;
  }

  get hasAdvisory (): boolean {
    return this.drivewealthWizardStore.filteredEnrollmentType &&
        this.drivewealthWizardStore.filteredEnrollmentType.hasAdvisory;
  }

  get hasRiaManaged (): boolean {
    return this.featureFlagStore.flags.drivewealthAllowManagedSignup &&
        this.drivewealthWizardStore.filteredEnrollmentType &&
        this.drivewealthWizardStore.filteredEnrollmentType.hasRiaManaged;
  }

  get hasSelfDirected (): boolean {
    return this.featureFlagStore.flags.drivewealthAllowSelfSignup &&
        this.drivewealthWizardStore.filteredEnrollmentType &&
        this.drivewealthWizardStore.filteredEnrollmentType.hasSelfDirected;
  }

  get onlyOneChoice (): boolean {
    return ((this.hasAdvisory ? 1 : 0)
        + (this.hasRiaManaged ? 1 : 0)
        + (this.hasSelfDirected ? 1 : 0)) === 1;
  }

  @Watch("oneChoiceValue")
  oneChoiceValueChanged (): void {
    this.$emit("oneChoiceValue", this.oneChoiceValue);
  }

  get oneChoiceValue (): DrivewealthAccountManagementType {
    return (!this.onlyOneChoice || !this.drivewealthWizardStore.enrollmentTypeLoaded) ?
        null
        : this.hasAdvisory ?
            DrivewealthAccountManagementType.Advisory
            : this.hasRiaManaged ?
                DrivewealthAccountManagementType.RiaManaged
                : DrivewealthAccountManagementType.OpenBrokerage;
  }

  get disableAdvisory (): boolean {
    return this.drivewealthStore.hasAnAccount &&
        this.drivewealthStore.isAccountManagementType(DrivewealthAccountManagementType.Advisory);
  }

  get disableRiaManaged (): boolean {
    return this.drivewealthStore.hasAnAccount &&
        this.drivewealthStore.isAccountManagementType(DrivewealthAccountManagementType.RiaManaged);
  }

  get disableSelfDirected (): boolean {
    return this.drivewealthStore.hasAnAccount &&
        this.drivewealthStore.isAccountManagementType(DrivewealthAccountManagementType.OpenBrokerage);
  }
}
